import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled from "styled-components";
import StringUtils from "util/StringUtils";
import { Alert } from "components/bootstrap";
import useGranteeTypeLabel from "components/permissions/useGranteeTypeLabel";
const Container = styled(Alert)`
  margin-top: 20px;
  max-height: 240px;
  overflow: auto;
`;
const List = styled.ul`
  list-style: initial;
  padding-left: 20px;

  ul {
    list-style: circle;
  }
`;
const _cap = StringUtils.capitalizeFirstLetter;
const DependenciesWarning = ({ missingDependencies, availableGrantees }) => {
  const { t } = useTranslation("users");
  const granteeTypeLabel = useGranteeTypeLabel();
  return /* @__PURE__ */ React.createElement(Container, { bsStyle: "danger", title: t("permissions.dependencies_warning.title") }, /* @__PURE__ */ React.createElement(List, null, missingDependencies.entrySeq().map(([granteeGRN, dependencyList]) => {
    const grantee = availableGrantees.find((selectedGrantee) => selectedGrantee.id === granteeGRN);
    return grantee && /* @__PURE__ */ React.createElement("li", { key: grantee.id }, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "permissions.dependencies_warning.needs_access",
        values: { type: granteeTypeLabel(grantee.type), title: grantee.title },
        components: { granteeTitle: /* @__PURE__ */ React.createElement("i", null) }
      }
    ), dependencyList.map((dependency) => /* @__PURE__ */ React.createElement(List, { key: dependency.id }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "permissions.dependencies_warning.dependency",
        values: { type: _cap(dependency.type), title: dependency.title },
        components: { dependencyTitle: /* @__PURE__ */ React.createElement("i", null) }
      }
    ), /* @__PURE__ */ React.createElement("br", null), t("permissions.dependencies_warning.owners"), " ", dependency.owners.map((owner, key) => /* @__PURE__ */ React.createElement("span", { key: owner.id }, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "permissions.dependencies_warning.owner",
        values: { type: granteeTypeLabel(owner.type), title: owner.title },
        components: { ownerTitle: /* @__PURE__ */ React.createElement("i", null) }
      }
    ), key !== dependency.owners.size - 1 && ", "))))));
  }).toArray()));
};
export default DependenciesWarning;
